import "./AccessInvitesForm.css";

import { OrganisationPermissionConstants } from "../../../../../../constants";
import { Column, Row, Toggle } from "../../../../../../widget";
import { OrganisationDetailsData, UpdateDetailsType } from "../../models";
import { useAccessInvitesForm } from "./useAccessInvitesForm";

interface AccessInvitesFormProps {
  objectUuid: string;
  objectKey: string;
  updateDetails: UpdateDetailsType;
  organisationDefaultDetails: OrganisationDetailsData;
  onDetailsUpdated: (details: OrganisationDetailsData) => void;
}

export const AccessInvitesForm = ({
  objectUuid,
  objectKey,
  updateDetails,
  organisationDefaultDetails,
  onDetailsUpdated,
}: AccessInvitesFormProps): JSX.Element => {
  const { allowInvitations, isSaving, handleChange, hasPermission } = useAccessInvitesForm(
    objectUuid,
    objectKey,
    updateDetails,
    organisationDefaultDetails,
    onDetailsUpdated
  );

  return (
    <>
      <Row spacingV="ll">
        <Column span={12}>
          <h2>Organisation preferences</h2>
        </Column>
      </Row>
      <Row spacingV="ll" className="AccessInvitesForm_preferenceRow">
        <Column span={12}>
          <div className="AccessInvitesForm_preference">
            <Toggle
              value={allowInvitations}
              disabled={isSaving || !hasPermission(OrganisationPermissionConstants.WRITE_ORGANISATION)}
              onChange={handleChange}
            />
            <div className="AccessInvitesForm_text">
              <span className="body1 AccessInvitesForm_label">Allow project access invitations</span>
              <span className="body1">
                When off, no one in your organisation will receive invitations to join projects.
              </span>
            </div>
          </div>
        </Column>
      </Row>
    </>
  );
};
